import React, { useEffect, useState } from "react";

import apiClient from "../../../services/apiClient";
import { openMonthlySummary } from "./monthlySummaryOpen";
import { CONTAINER_MAX_WIDTH } from "../../../styles/layout";

// 월간 보고서 탭. 달마다 쌓이는 진단 보고서를 여기서 다시 본다.
//
// 보고서 자체는 서버가 만든 HTML 한 장이라 앱 안에서 띄운다(`openMonthlySummary`).
// 화면에 같은 내용을 다시 그리면 두 벌이 되어 한쪽만 고쳐진다.
const MonthlyReportPage = () => {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  const isMobile = Math.min(window.innerWidth, window.screen.width) <= 768;

  useEffect(() => {
    apiClient
      .get("/api/v1/echo/monthly-summary/months", { withAuth: true })
      .then((response) => setRows(response.data.rows || []))
      .catch(() => setError("보고서 목록을 불러오지 못했습니다."));
  }, []);

  return (
    <div
      style={{
        maxWidth: `${CONTAINER_MAX_WIDTH}px`,
        margin: "0 auto",
        padding: isMobile ? "16px 14px 40px" : "24px 28px 60px",
      }}
    >
      <div className="section-title" style={{ marginBottom: "8px" }}>
        월간 보고서
      </div>
      <p style={{ fontSize: "14px", color: "#5b666f", lineHeight: 1.7, margin: "0 0 22px" }}>
        달마다 우리 학원의 학습 상태를 진단해 드립니다. 다른 학원과 견준 자리, 아이별
        현황, 다음 달에 바꾸면 좋을 것을 정리했습니다. 매월 말에 새 보고서가 올라옵니다.
      </p>

      {error && <p style={{ color: "#c4551c" }}>{error}</p>}
      {rows === null && !error && (
        <p style={{ color: "#8a949c", fontSize: "14px" }}>불러오는 중입니다...</p>
      )}
      {rows && rows.length === 0 && (
        <p style={{ color: "#8a949c", fontSize: "14px" }}>
          아직 보고서가 없습니다. 과제를 출제하시면 그 달부터 만들어집니다.
        </p>
      )}

      <div style={{ display: "grid", gap: "10px" }}>
        {(rows || []).map((row) => (
          <div
            key={row.month}
            style={{
              border: "1px solid #E3EBEA",
              borderLeft: "4px solid #00A396",
              background: "#fff",
              padding: isMobile ? "14px 16px" : "18px 20px",
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: isMobile ? "stretch" : "center",
              justifyContent: "space-between",
              gap: "12px",
            }}
          >
            <div>
              <div style={{ fontSize: "16px", fontWeight: 800, marginBottom: "3px" }}>
                {row.label} 학습 진단
                {!row.opened && (
                  <span
                    style={{
                      marginLeft: "8px",
                      fontSize: "11px",
                      fontWeight: 800,
                      color: "#fff",
                      background: "#00A396",
                      padding: "2px 7px",
                      verticalAlign: "middle",
                    }}
                  >
                    새 보고서
                  </span>
                )}
              </div>
              <div style={{ fontSize: "13px", color: "#8a949c" }}>
                그 달에 낸 과제 {row.given.toLocaleString()}건
              </div>
            </div>
            <button
              type="button"
              onClick={() =>
                openMonthlySummary({ month: row.month, title: `${row.label} 학습 진단` })
              }
              style={{
                background: "#0E141B",
                color: "#fff",
                border: "none",
                fontWeight: 800,
                fontSize: "14px",
                padding: "11px 20px",
                cursor: "pointer",
                whiteSpace: "nowrap",
              }}
            >
              보고서 열기
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MonthlyReportPage;
